import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function PostContent({ post }) {
  return (
    <div className="post-content">
      <div className="title-wrapper">
        <h1>{post.title}</h1>
      </div>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {post.content}
      </ReactMarkdown>
  </div>
  );
}

export default PostContent;
